import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { navigate } from "gatsby"

import Tag from "../../tag/tag"
import ResultImageGroup from "../resultsimage/resultsimagegroup"
import ResultsDisclaimer from "../resultsdisclaimer/resultsdisclaimer"

import { Name, Quote, ProductText, TagsContainer } from "./resultscard.styled"

const CardWrapper = styled(Flex)`
  height: 100%;
  border-radius: 4px;
  flex-direction: column;
  max-width: 910px;
  margin: 0 auto;
  @media (min-width: ${theme.mediaqueries.large}) {
    flex-direction: row;
    max-width: none;
  }
`

const ImageWrapper = styled(Box)`
  margin: 0 auto;
  @media (min-width: ${theme.mediaqueries.large}) {
    max-width: none;
  }
`

const ResultsInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 16px;
  border: 1px ${theme.wild.color.nova.transparency.black[20]} solid;

  @media (max-width: 1279px) {
    border-top: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  @media (min-width: 768px) {
    padding: 24px;
  }
  @media (min-width: 1280px) {
    border-left: none;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    padding: 16px 16px;
  }
  @media (min-width: 1440px) {
    padding: 32px;
  }
`

const ContentWrapper = styled(Flex)`
  justify-content: space-between;
  height: 100%;
  @media (min-width: ${theme.mediaqueries.medium}) {
  }
`

const onClick = (pdp, product) => {
  if (pdp && product) {
    const eventObj = {
      destination: pdp,
      text: product,
      type: "link",
      module_location: "mid_fold",
      module_name: "Before & After",
    }
    navigate(pdp)
    segmentEvent("Marketing CTA Clicked", eventObj)
  }
}

const ResultsCardAlt = ({
  afterImage,
  beforeImage,
  imageDirection = "center",
  after,
  name,
  quote,
  product,
  pdp,
  tags,
  action,
  badgePosition = "bottom-left",
  slideDisclaimer = null,
  disclaimer,
  showDisclaimer = true,
  linkProduct = true,
}) => {
  const resultImageData = {
    badgePosition,
    imageDirection,
    before: {
      image: beforeImage,
      label: "Before",
      alt: `${name} before ${action.toLowerCase()} ${product}.`,
      role: "presentation",
    },
    after: {
      image: afterImage,
      label: `${after} months growing`,
      alt: `${name} ${after} months into ${action.toLowerCase()} ${product}. Results are from a clinical study and may vary`,
      role: "presentation",
    },
  }

  return (
    <CardWrapper>
      <ImageWrapper width={[1, 1, 1, 1, 2 / 3]}>
        <ResultImageGroup {...resultImageData} />
      </ImageWrapper>
      <ResultsInfoWrapper width={[1, 1, 1, 1, 1 / 3]}>
        <ContentWrapper
          flexDirection="column"
          width="100%"
          maxWidth={[null, null, null]}
        >
          <Box>
            {quote ? (
              <Quote
                element="p"
                text={`&ldquo;${quote}&rdquo;`}
                className="Subtitle-10-Dia-Normal"
              />
            ) : null}
            {name ? (
              <Name
                element="h3"
                text={name}
                className="Caption-10-Dia-Uppercase quote"
              />
            ) : null}
            {tags ? (
              <TagsContainer mt={[40, 40, 32, 40]} mb={[40, 40, 48, 40]}>
                {tags?.map((tag) => (
                  <Tag key={tag} data={{ line: tag }} />
                ))}
              </TagsContainer>
            ) : null}
          </Box>
          <Box>
            {product ? (
              <>
                {linkProduct ? (
                  <ProductText
                    onClick={() => {
                      onClick(pdp, product)
                    }}
                    className={`CTA-20-Dia-Normal text-nova-transparency-black-70 cursor-pointer ${
                      pdp && product ? "link" : ""
                    }`}
                    text={`${action} <a>${product}</a>`}
                  />
                ) : (
                  <ProductText
                    className={`CTA-20-Dia-Normal text-nova-transparency-black-70`}
                    text={`${action} <span class='text-nova-brand-primary-80'>${product}</span>`}
                  />
                )}
              </>
            ) : null}
            {showDisclaimer ? (
              <ResultsDisclaimer data={slideDisclaimer ?? disclaimer} />
            ) : null}
          </Box>
        </ContentWrapper>
      </ResultsInfoWrapper>
    </CardWrapper>
  )
}

export default ResultsCardAlt
